import BrandLogo from '../brand/BrandLogo';
import { LottieLoader } from '../loading/LottieLoader';
import styles from './SiteRedirectInterstitial.module.scss';

export function SiteRedirectInterstitial({
  title,
  why,
  statusMessage,
  slowMessage = '',
  showSlowMessage = false,
  showManualContinue = false,
  continueHref,
  continueLabel,
}) {
  return (
    <main className={styles.shell}>
      <div className={styles.backgroundGlow} aria-hidden="true" />
      <div className={styles.meshOverlay} aria-hidden="true" />
      <div className={styles.backgroundSweep} aria-hidden="true" />

      <div className={styles.frame}>
        <header className={styles.header}>
          <BrandLogo className={styles.logo} variant="site" href="/" size="nav" />
          <a className={styles.backLink} href="/">
            Back to cedrum.app
          </a>
        </header>

        <section className={styles.panel} aria-busy="true">
          <div className={styles.copy}>
            <p className={styles.eyebrow}>cedrum redirect</p>
            <h1 className={styles.title}>{title}</h1>
            <p className={styles.why}>{why}</p>
          </div>

          <div className={styles.loaderSlot}>
            <LottieLoader label={statusMessage} layout="block" size="lg" showLabel={false} />
            <p className={styles.statusMessage}>{statusMessage}</p>
            {showSlowMessage && slowMessage ? (
              <p className={styles.slowMessage}>{slowMessage}</p>
            ) : null}
            {showManualContinue ? (
              <a className={styles.continueLink} href={continueHref}>
                {continueLabel}
              </a>
            ) : null}
          </div>
        </section>
      </div>
    </main>
  );
}
